import { render, staticRenderFns } from "./cpx_related_products.vue?vue&type=template&id=234d346e&scoped=true"
import script from "./cpx_related_products.vue?vue&type=script&lang=js"
export * from "./cpx_related_products.vue?vue&type=script&lang=js"
import style0 from "./cpx_related_products.vue?vue&type=style&index=0&id=234d346e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234d346e",
  null
  
)

export default component.exports